<script setup lang="ts">
import { useComments } from '~/api/drupal'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  postId: string
  status: number
  count: number
}>()

const isSubmissionOpen = computed(() => props.status === 2)
const hasComments = computed(() => props.status === 1 && props.count > 0)
const shouldDisplay = computed(() => isSubmissionOpen.value || hasComments.value)

const { items } = await useComments(props.postId)

const { setPostId, parent } = useCommentForm()

if (isSubmissionOpen && props.postId) {
  setPostId(+props.postId)
}

onUnmounted(() => {
  setPostId(null)
})
</script>
<template>
  <Section v-if="shouldDisplay">
    <div :id="parent.default" class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <SectionTitle :title="t('news.detail.comments.title')" />
      <Comments :items="items" />
      <CommentForm />
    </div>
  </Section>
</template>
<style lang="scss" scoped></style>
